import * as Sentry from "@sentry/react";
import type { ReactElement, ReactNode } from "react";

function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-md px-6">
        <h1 className="text-2xl font-bold text-foreground mb-2">Something went wrong</h1>
        <p className="text-muted-foreground mb-4">
          An unexpected error occurred. Please try refreshing the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-full text-sm font-medium hover:bg-primary/90 transition-colors"
        >
          Refresh page
        </button>
      </div>
    </div>
  );
}

interface Props {
  children: ReactNode;
  fallback?: ReactElement;
}

export default function ErrorBoundary({ children, fallback }: Props) {
  return (
    <Sentry.ErrorBoundary fallback={fallback ?? <ErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
